module.exports = __webpack_public_path__ + "static/media/team-default-avatar.24189b98.svg";